<template>
    <div class="designeroption" :data-designer-component-id="component_id" v-if="options_loaded && passed_filter && panel_required">
        <h3>{{ maintitle }}</h3>
        <div class="designer-floating-sidebar-message" v-if="floating_sidebar_message">
            <i class="fa fa-circle-question"></i>
            <span v-html="floating_sidebar_message"></span>
        </div>
        <div class="stylesoption">
            <table>
                <tbody>
                    <tr>
                        <td class="p-1"><strong>{{ title }}</strong></td>
                        <td class="p-1">
                            <table>
                                <tbody>
                                <tr>
                                    <td class="p-1">
                                        <select class="form-control" v-model="localTarget">
                                            <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                                        </select>
                                    </td>
                                    <td class="p-1" v-if="key_amount_text">
                                        {{ key_amount_text }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            maintitle: {
              default() {
                return 'Extra Keys';
              }
            },
            title: {
                default(){
                    return 'How many extra keys would you like?';
                }
            },
            component_id: {
                default(){
                    return 'keys';
                }
            },
            keyAttribute: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.fabricator, this.keyAttribute);
            },
            url(){
                return '/api/options/' + this.fabricator + '/key-qty?key=' + this.keyAttribute;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.keyAttribute;
            },
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            },
            key_amount_text() {
              return "";
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
